import { useContext, useEffect } from "react";
import { getUserData } from "api/UserApi";
import { canParseJSON, tryCatchWrapper } from "helpers/common";
import { useDispatch } from "react-redux";
import { setUserPreferences } from "redux/actions/portal/usersActionCreator";
import { UserContext } from "context/AppProvider/UserContext";
import useLogout from "hooks/useLogout";
import { fetchCustomerSubscription } from "redux/actions/portal/subscriptionsActionCreator";
import { useAuth0 } from "@auth0/auth0-react";

export const useSetUserData = (accessToken) => {
  const dispatch = useDispatch();
  const { setUserData, userData } = useContext(UserContext);
  const { portalLogout } = useLogout();
  const { user } = useAuth0();

  useEffect(() => {
    const fetchUser = async (auth0_id, tenant_id) => {
      try {
        const fetchUserResponse = await getUserData(auth0_id, tenant_id);
        const userPreference = canParseJSON(fetchUserResponse?.user_preferences)
          ? JSON.parse(fetchUserResponse?.user_preferences)
          : {};

        dispatch(setUserPreferences(userPreference));

        setUserData(fetchUserResponse);
        if (fetchUserResponse?.status === "suspended") {
          portalLogout(true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (accessToken) {
      if (!userData) {
        tryCatchWrapper(fetchUser)(user?.cxfUserId, user?.stripeId);
      }

      dispatch(fetchCustomerSubscription(user?.stripeId));
    }
  }, [user, accessToken]);
};
